import { Permission } from '@/context/auth-context';

export interface ModuleInfo {
  name: string;
  icon: React.ReactNode;
  href: string;
  routesToMatch: { path: string }[];
  label: React.ReactNode;
  pageTitle?: string;
  minRole: 'Admin' | 'Owner' | 'Member';
  sideBarSectionName?: string;
  /** When set, sidebar hides this item unless the user has the permission. */
  permission?: Permission;
}

export const APP_ROUTES: ModuleInfo[] = [
  {
    name: 'Kintsugi Filings',
    icon: null,
    href: '/kintsugi-filings',
    routesToMatch: [{ path: '/' }, { path: '/kintsugi-filings' }],
    label: 'Kintsugi Filings',
    pageTitle: 'Kintsugi Filings',
    minRole: 'Member',
    sideBarSectionName: 'Task Management',
  },
  {
    name: 'Kintsugi Registrations',
    icon: null,
    href: '/kintsugi-registrations',
    routesToMatch: [{ path: '/kintsugi-registrations' }],
    label: 'Kintsugi Registrations',
    pageTitle: 'Kintsugi Registrations',
    minRole: 'Member',
    sideBarSectionName: 'Task Management',
  },
  {
    name: 'Kintsugi Tasks',
    icon: null,
    href: '/kintsugi-tasks',
    routesToMatch: [{ path: '/kintsugi-tasks' }],
    label: 'Kintsugi Tasks',
    pageTitle: 'Kintsugi Tasks',
    minRole: 'Member',
    sideBarSectionName: 'Task Management',
  },
  {
    name: 'Kintsugi CX',
    icon: null,
    href: '/kintsugi-cx',
    routesToMatch: [{ path: '/kintsugi-cx' }],
    label: 'Kintsugi CX',
    pageTitle: 'Kintsugi CX',
    minRole: 'Member',
    sideBarSectionName: 'Task Management',
  },
  {
    name: 'Kintsugi CSP',
    icon: null,
    href: '/csm',
    routesToMatch: [{ path: '/csm' }],
    label: 'Kintsugi CSP',
    pageTitle: 'Kintsugi CSP',
    minRole: 'Member',
    sideBarSectionName: 'Task Management',
    permission: Permission.CAN_VIEW_CSM_WORKSPACE,
  },
  {
    name: 'Billing Change Requests',
    icon: null,
    href: '/billing-change-requests',
    routesToMatch: [{ path: '/billing-change-requests' }],
    label: 'Billing Change Requests',
    pageTitle: 'Billing Change Requests',
    minRole: 'Member',
    sideBarSectionName: 'Task Management',
  },
  {
    name: 'Organization',
    icon: null,
    href: '/organization',
    routesToMatch: [
      { path: '/organization/:orgId' },
      { path: '/organization/:orgId/details' },
      { path: '/organization/:orgId/history' },
      { path: '/organization/:orgId/settings' },
    ],
    label: 'Organization',
    pageTitle: 'Organization',
    minRole: 'Member',
    sideBarSectionName: 'Organizations & Portfolios',
  },
  {
    name: 'Billing & Access Control',
    icon: null,
    href: '/billing-access-control/:orgId',
    routesToMatch: [{ path: '/billing-access-control/:orgId' }],
    label: 'Billing & Access Control',
    pageTitle: 'Billing & Access Control',
    minRole: 'Member',
    sideBarSectionName: 'Organizations & Portfolios',
  },
  {
    name: 'Registrations',
    icon: null,
    href: '/registrations',
    routesToMatch: [
      { path: '/registrations/:orgId' },
      { path: '/registrations/:orgId/:id' },
      { path: '/registrations/:orgId/:id/details' },
    ],
    label: 'Registrations',
    pageTitle: 'Registrations',
    minRole: 'Member',
    sideBarSectionName: 'Organizations & Portfolios',
  },
  {
    name: 'Filings',
    icon: null,
    href: '/filings',
    routesToMatch: [{ path: '/filings/:orgId' }, { path: '/filings/:orgId/list' }, { path: '/filings/:orgId/:id' }],
    label: 'Filings',
    pageTitle: 'Filings',
    minRole: 'Member',
    sideBarSectionName: 'Organizations & Portfolios',
  },
  {
    name: 'Connections',
    icon: null,
    href: '/connections',
    routesToMatch: [{ path: '/connections/:orgId' }],
    label: 'Connections',
    pageTitle: 'Connections',
    minRole: 'Member',
    sideBarSectionName: 'Organizations & Portfolios',
  },
  {
    name: 'Transactions',
    icon: null,
    href: '/transactions',
    routesToMatch: [
      { path: '/transactions/:orgId' },
      { path: '/transactions/:orgId/:transactionId' },
      { path: '/transactions/:orgId/:transactionId/processing-timeline' },
    ],
    label: 'Transactions',
    pageTitle: 'Transactions',
    minRole: 'Member',
    sideBarSectionName: 'Organizations & Portfolios',
  },
  {
    name: 'Nexus',
    icon: null,
    href: '/nexus',
    routesToMatch: [{ path: '/nexus/:orgId' }, { path: '/nexus/:orgId/:id' }],
    label: 'Nexus',
    pageTitle: 'Nexus',
    minRole: 'Member',
    sideBarSectionName: 'Organizations & Portfolios',
  },
  {
    name: 'Attachments',
    icon: null,
    href: '/attachments',
    routesToMatch: [{ path: '/attachments/:orgId' }],
    label: 'Attachments',
    pageTitle: 'Attachments',
    minRole: 'Member',
    sideBarSectionName: 'Organizations & Portfolios',
  },
  {
    name: 'Documents',
    icon: null,
    href: '/documents',
    routesToMatch: [{ path: '/documents/:orgId' }, { path: '/documents/:orgId/:catalogType' }],
    label: 'Compliance Documents',
    pageTitle: 'Compliance Documents',
    minRole: 'Member',
    sideBarSectionName: 'Organizations & Portfolios',
  },
  {
    name: 'File Imports',
    icon: null,
    href: '/file-imports',
    routesToMatch: [{ path: '/file-imports/:orgId' }],
    label: 'File Imports',
    pageTitle: 'File Imports',
    minRole: 'Member',
    sideBarSectionName: 'Organizations & Portfolios',
  },
  {
    name: 'Physical Presence',
    icon: null,
    href: '/physical-presence',
    routesToMatch: [{ path: '/physical-presence/:orgId' }],
    label: 'Physical Presence',
    pageTitle: 'Physical Presence',
    minRole: 'Member',
    sideBarSectionName: 'Organizations & Portfolios',
  },
  {
    name: 'Reports',
    icon: null,
    href: '/reports',
    routesToMatch: [{ path: '/reports' }],
    label: 'Reports',
    pageTitle: 'Reports',
    minRole: 'Member',
    sideBarSectionName: 'Reports & Tools',
  },
  {
    name: 'Tools',
    icon: null,
    href: '/tools',
    routesToMatch: [
      { path: '/tools' },
      { path: '/tools/vda' },
      { path: '/tools/vda/config' },
      { path: '/tools/vda/:orgId' },
      { path: '/tools/filing-operations' },
      { path: '/tools/filing-projection' },
      { path: '/tools/workload-detail' },
      { path: '/tools/effort-rates' },
      { path: '/tools/proposals' },
      { path: '/tools/health-check-signal-cadences' },
      { path: '/tools/queues' },
      { path: '/tools/mobile-notifications' },
      { path: '/tools/bulk-report-rebuild' },
      { path: '/tools/tax-research' },
      { path: '/tax-rules/*' },
    ],
    label: 'Tools',
    pageTitle: 'Tools',
    minRole: 'Member',
    sideBarSectionName: 'Reports & Tools',
  },
  {
    name: 'Filing Automation',
    icon: null,
    href: '/filing-automation',
    routesToMatch: [
      { path: '/filing-automation' },
      { path: '/filing-automation/connecticut' },
      { path: '/filing-automation/pennsylvania' },
    ],
    label: 'Filing Automation',
    pageTitle: 'Filing Automation',
    minRole: 'Member',
    sideBarSectionName: 'Reports & Tools',
    // Same permission that gates filing management on Kintsugi Filings.
    permission: Permission.CAN_MANAGE_KINTSUGI_FILINGS,
  },
  {
    name: 'Portfolios',
    icon: null,
    href: '/partners',
    routesToMatch: [{ path: '/partners' }],
    label: 'Portfolios',
    pageTitle: 'Portfolios',
    minRole: 'Member',
    sideBarSectionName: 'Reports & Tools',
  },
  {
    name: 'Vertex Partitions',
    icon: null,
    href: '/vertex-partitions',
    routesToMatch: [{ path: '/vertex-partitions' }],
    label: 'Vertex Partitions',
    pageTitle: 'Vertex Partitions',
    minRole: 'Member',
    sideBarSectionName: 'Reports & Tools',
    permission: Permission.CAN_MANAGE_VERTEX_PARTITIONS,
  },
  {
    name: 'Portfolio',
    icon: null,
    href: '/partners/:id',
    routesToMatch: [{ path: '/partners/:id' }],
    label: 'Portfolio',
    pageTitle: 'Portfolio',
    minRole: 'Member',
    sideBarSectionName: 'Organizations & Portfolios',
  },
  {
    name: 'Billing & Access Control',
    icon: null,
    href: '/partners/:id/billing-access',
    routesToMatch: [
      { path: '/partners/:id/billing-access' },
      { path: '/partners/:id/access-settings' },
      { path: '/partners/:id/country-settings' },
    ],
    label: 'Billing & Access Control',
    pageTitle: 'Billing & Access Control',
    minRole: 'Member',
    sideBarSectionName: 'Organizations & Portfolios',
    permission: Permission.CAN_MANAGE_PARTNERS,
  },
  {
    name: 'Resellers',
    icon: null,
    href: '/resellers',
    routesToMatch: [{ path: '/resellers' }],
    label: 'Resellers',
    pageTitle: 'Resellers',
    minRole: 'Member',
    sideBarSectionName: 'Reports & Tools',
  },
  {
    name: 'Reseller',
    icon: null,
    href: '/resellers/:id',
    routesToMatch: [{ path: '/resellers/:id' }],
    label: 'Reseller',
    pageTitle: 'Reseller',
    minRole: 'Member',
    // Detail route reached from the Resellers list. No sideBarSectionName so it
    // does not render as a sidebar nav item; it stays registered here only for
    // the header label and active-state matching.
  },
  {
    name: 'Portfolio History',
    icon: null,
    href: '/partners/:id/history',
    routesToMatch: [{ path: '/partners/:id/history' }],
    label: 'Portfolio History',
    pageTitle: 'Portfolio History',
    minRole: 'Member',
    sideBarSectionName: 'Organizations & Portfolios',
  },
  {
    name: 'Portfolio Settings',
    icon: null,
    href: '/partners/:id/settings',
    routesToMatch: [{ path: '/partners/:id/settings' }],
    label: 'Portfolio Settings',
    pageTitle: 'Portfolio Settings',
    minRole: 'Member',
    sideBarSectionName: 'Organizations & Portfolios',
    permission: Permission.CAN_MANAGE_PARTNERS,
  },
];

export type CountryStateOptionsType = { label: string; value: string };
export type CountryOptionsType = { label: string; value: string };

export const Countries: CountryOptionsType[] = [
  { value: 'AF', label: 'Afghanistan' },
  { value: 'AX', label: 'Åland Islands' },
  { value: 'AL', label: 'Albania' },
  { value: 'DZ', label: 'Algeria' },
  { value: 'AS', label: 'American Samoa' },
  { value: 'AD', label: 'Andorra' },
  { value: 'AO', label: 'Angola' },
  { value: 'AI', label: 'Anguilla' },
  { value: 'AQ', label: 'Antarctica' },
  { value: 'AG', label: 'Antigua and Barbuda' },
  { value: 'AR', label: 'Argentina' },
  { value: 'AM', label: 'Armenia' },
  { value: 'AW', label: 'Aruba' },
  { value: 'AU', label: 'Australia' },
  { value: 'AT', label: 'Austria' },
  { value: 'AZ', label: 'Azerbaijan' },
  { value: 'BS', label: 'Bahamas' },
  { value: 'BH', label: 'Bahrain' },
  { value: 'BD', label: 'Bangladesh' },
  { value: 'BB', label: 'Barbados' },
  { value: 'BY', label: 'Belarus' },
  { value: 'BE', label: 'Belgium' },
  { value: 'BZ', label: 'Belize' },
  { value: 'BJ', label: 'Benin' },
  { value: 'BM', label: 'Bermuda' },
  { value: 'BT', label: 'Bhutan' },
  { value: 'BO', label: 'Bolivia' },
  { value: 'BQ', label: 'Bonaire, Sint Eustatius and Saba' },
  { value: 'BA', label: 'Bosnia and Herzegovina' },
  { value: 'BW', label: 'Botswana' },
  { value: 'BV', label: 'Bouvet Island' },
  { value: 'BR', label: 'Brazil' },
  { value: 'IO', label: 'British Indian Ocean Territory' },
  { value: 'BN', label: 'Brunei' },
  { value: 'BG', label: 'Bulgaria' },
  { value: 'BF', label: 'Burkina Faso' },
  { value: 'BI', label: 'Burundi' },
  { value: 'CV', label: 'Cabo Verde' },
  { value: 'KH', label: 'Cambodia' },
  { value: 'CM', label: 'Cameroon' },
  { value: 'CA', label: 'Canada' },
  { value: 'KY', label: 'Cayman Islands' },
  { value: 'CF', label: 'Central African Republic' },
  { value: 'TD', label: 'Chad' },
  { value: 'CL', label: 'Chile' },
  { value: 'CN', label: 'China' },
  { value: 'CX', label: 'Christmas Island' },
  { value: 'CC', label: 'Cocos (Keeling) Islands' },
  { value: 'CO', label: 'Colombia' },
  { value: 'KM', label: 'Comoros' },
  { value: 'CG', label: 'Congo' },
  { value: 'CD', label: 'Congo (Democratic Republic of the)' },
  { value: 'CK', label: 'Cook Islands' },
  { value: 'CR', label: 'Costa Rica' },
  { value: 'CI', label: `Cote D'Ivoire (Ivory Coast)` },
  { value: 'HR', label: 'Croatia' },
  { value: 'CU', label: 'Cuba' },
  { value: 'CW', label: 'Curaçao' },
  { value: 'CY', label: 'Cyprus' },
  { value: 'CZ', label: 'Czechia' },
  { value: 'DK', label: 'Denmark' },
  { value: 'DJ', label: 'Djibouti' },
  { value: 'DM', label: 'Dominica' },
  { value: 'DO', label: 'Dominican Republic' },
  { value: 'EC', label: 'Ecuador' },
  { value: 'EG', label: 'Egypt' },
  { value: 'SV', label: 'El Salvador' },
  { value: 'GQ', label: 'Equatorial Guinea' },
  { value: 'ER', label: 'Eritrea' },
  { value: 'EE', label: 'Estonia' },
  { value: 'SZ', label: 'Eswatini' },
  { value: 'ET', label: 'Ethiopia' },
  { value: 'FK', label: 'Falkland Islands (Malvinas)' },
  { value: 'FO', label: 'Faroe Islands' },
  { value: 'FJ', label: 'Fiji' },
  { value: 'FI', label: 'Finland' },
  { value: 'FR', label: 'France' },
  { value: 'GF', label: 'French Guiana' },
  { value: 'PF', label: 'French Polynesia' },
  { value: 'TF', label: 'French Southern Territories' },
  { value: 'GA', label: 'Gabon' },
  { value: 'GM', label: 'Gambia' },
  { value: 'GE', label: 'Georgia' },
  { value: 'DE', label: 'Germany' },
  { value: 'GH', label: 'Ghana' },
  { value: 'GI', label: 'Gibraltar' },
  { value: 'GR', label: 'Greece' },
  { value: 'GL', label: 'Greenland' },
  { value: 'GD', label: 'Grenada' },
  { value: 'GP', label: 'Guadeloupe' },
  { value: 'GU', label: 'Guam' },
  { value: 'GT', label: 'Guatemala' },
  { value: 'GG', label: 'Guernsey' },
  { value: 'GN', label: 'Guinea' },
  { value: 'GW', label: 'Guinea-Bissau' },
  { value: 'GY', label: 'Guyana' },
  { value: 'HT', label: 'Haiti' },
  { value: 'HM', label: 'Heard Island and McDonald Islands' },
  { value: 'VA', label: 'Holy See' },
  { value: 'HN', label: 'Honduras' },
  { value: 'HK', label: 'Hong Kong' },
  { value: 'HU', label: 'Hungary' },
  { value: 'IS', label: 'Iceland' },
  { value: 'IN', label: 'India' },
  { value: 'ID', label: 'Indonesia' },
  { value: 'IR', label: 'Iran' },
  { value: 'IQ', label: 'Iraq' },
  { value: 'IE', label: 'Ireland' },
  { value: 'IM', label: 'Isle of Man' },
  { value: 'IL', label: 'Israel' },
  { value: 'IT', label: 'Italy' },
  { value: 'JM', label: 'Jamaica' },
  { value: 'JP', label: 'Japan' },
  { value: 'JE', label: 'Jersey' },
  { value: 'JO', label: 'Jordan' },
  { value: 'KZ', label: 'Kazakhstan' },
  { value: 'KE', label: 'Kenya' },
  { value: 'KI', label: 'Kiribati' },
  { value: 'KP', label: 'North Korea' },
  { value: 'KR', label: 'South Korea' },
  { value: 'KW', label: 'Kuwait' },
  { value: 'KG', label: 'Kyrgyzstan' },
  { value: 'LA', label: 'Laos' },
  { value: 'LV', label: 'Latvia' },
  { value: 'LB', label: 'Lebanon' },
  { value: 'LS', label: 'Lesotho' },
  { value: 'LR', label: 'Liberia' },
  { value: 'LY', label: 'Libya' },
  { value: 'LI', label: 'Liechtenstein' },
  { value: 'LT', label: 'Lithuania' },
  { value: 'LU', label: 'Luxembourg' },
  { value: 'MO', label: 'Macao' },
  { value: 'MG', label: 'Madagascar' },
  { value: 'MW', label: 'Malawi' },
  { value: 'MY', label: 'Malaysia' },
  { value: 'MV', label: 'Maldives' },
  { value: 'ML', label: 'Mali' },
  { value: 'MT', label: 'Malta' },
  { value: 'MH', label: 'Marshall Islands' },
  { value: 'MQ', label: 'Martinique' },
  { value: 'MR', label: 'Mauritania' },
  { value: 'MU', label: 'Mauritius' },
  { value: 'YT', label: 'Mayotte' },
  { value: 'MX', label: 'Mexico' },
  { value: 'FM', label: 'Micronesia' },
  { value: 'MD', label: 'Moldova' },
  { value: 'MC', label: 'Monaco' },
  { value: 'MN', label: 'Mongolia' },
  { value: 'ME', label: 'Montenegro' },
  { value: 'MS', label: 'Montserrat' },
  { value: 'MA', label: 'Morocco' },
  { value: 'MZ', label: 'Mozambique' },
  { value: 'MM', label: 'Myanmar' },
  { value: 'NA', label: 'Namibia' },
  { value: 'NR', label: 'Nauru' },
  { value: 'NP', label: 'Nepal' },
  { value: 'NL', label: 'Netherlands' },
  { value: 'NC', label: 'New Caledonia' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'NI', label: 'Nicaragua' },
  { value: 'NE', label: 'Niger' },
  { value: 'NG', label: 'Nigeria' },
  { value: 'NU', label: 'Niue' },
  { value: 'NF', label: 'Norfolk Island' },
  { value: 'MK', label: 'North Macedonia' },
  { value: 'MP', label: 'Northern Mariana Islands' },
  { value: 'NO', label: 'Norway' },
  { value: 'OM', label: 'Oman' },
  { value: 'PK', label: 'Pakistan' },
  { value: 'PW', label: 'Palau' },
  { value: 'PS', label: 'Palestine' },
  { value: 'PA', label: 'Panama' },
  { value: 'PG', label: 'Papua New Guinea' },
  { value: 'PY', label: 'Paraguay' },
  { value: 'PE', label: 'Peru' },
  { value: 'PH', label: 'Philippines' },
  { value: 'PN', label: 'Pitcairn' },
  { value: 'PL', label: 'Poland' },
  { value: 'PT', label: 'Portugal' },
  { value: 'PR', label: 'Puerto Rico' },
  { value: 'QA', label: 'Qatar' },
  { value: 'RE', label: 'Réunion' },
  { value: 'RO', label: 'Romania' },
  { value: 'RU', label: 'Russia' },
  { value: 'RW', label: 'Rwanda' },
  { value: 'BL', label: 'Saint Barthélemy' },
  { value: 'SH', label: 'Saint Helena, Ascension and Tristan da Cunha' },
  { value: 'KN', label: 'Saint Kitts and Nevis' },
  { value: 'LC', label: 'Saint Lucia' },
  { value: 'MF', label: 'Saint Martin (French part)' },
  { value: 'PM', label: 'Saint Pierre and Miquelon' },
  { value: 'VC', label: 'Saint Vincent and the Grenadines' },
  { value: 'WS', label: 'Samoa' },
  { value: 'SM', label: 'San Marino' },
  { value: 'ST', label: 'Sao Tome and Principe' },
  { value: 'SA', label: 'Saudi Arabia' },
  { value: 'SN', label: 'Senegal' },
  { value: 'RS', label: 'Serbia' },
  { value: 'SC', label: 'Seychelles' },
  { value: 'SL', label: 'Sierra Leone' },
  { value: 'SG', label: 'Singapore' },
  { value: 'SX', label: 'Sint Maarten (Dutch part)' },
  { value: 'SK', label: 'Slovakia' },
  { value: 'SI', label: 'Slovenia' },
  { value: 'SB', label: 'Solomon Islands' },
  { value: 'SO', label: 'Somalia' },
  { value: 'ZA', label: 'South Africa' },
  { value: 'GS', label: 'South Georgia and the South Sandwich Islands' },
  { value: 'SS', label: 'South Sudan' },
  { value: 'ES', label: 'Spain' },
  { value: 'LK', label: 'Sri Lanka' },
  { value: 'SD', label: 'Sudan' },
  { value: 'SR', label: 'Suriname' },
  { value: 'SJ', label: 'Svalbard and Jan Mayen' },
  { value: 'SE', label: 'Sweden' },
  { value: 'CH', label: 'Switzerland' },
  { value: 'SY', label: 'Syria' },
  { value: 'TW', label: 'Taiwan' },
  { value: 'TJ', label: 'Tajikistan' },
  { value: 'TZ', label: 'Tanzania' },
  { value: 'TH', label: 'Thailand' },
  { value: 'TL', label: 'Timor-Leste' },
  { value: 'TG', label: 'Togo' },
  { value: 'TK', label: 'Tokelau' },
  { value: 'TO', label: 'Tonga' },
  { value: 'TT', label: 'Trinidad and Tobago' },
  { value: 'TN', label: 'Tunisia' },
  { value: 'TR', label: 'Turkey' },
  { value: 'TM', label: 'Turkmenistan' },
  { value: 'TC', label: 'Turks and Caicos Islands' },
  { value: 'TV', label: 'Tuvalu' },
  { value: 'UG', label: 'Uganda' },
  { value: 'UA', label: 'Ukraine' },
  { value: 'AE', label: 'United Arab Emirates' },
  { value: 'GB', label: 'United Kingdom' },
  { value: 'US', label: 'United States' },
  { value: 'UM', label: 'United States Minor Outlying Islands' },
  { value: 'UY', label: 'Uruguay' },
  { value: 'UZ', label: 'Uzbekistan' },
  { value: 'VU', label: 'Vanuatu' },
  { value: 'VE', label: 'Venezuela' },
  { value: 'VN', label: 'Vietnam' },
  { value: 'VG', label: 'Virgin Islands (British)' },
  { value: 'VI', label: 'Virgin Islands (U.S.)' },
  { value: 'WF', label: 'Wallis and Futuna' },
  { value: 'EH', label: 'Western Sahara' },
  { value: 'YE', label: 'Yemen' },
  { value: 'ZM', label: 'Zambia' },
  { value: 'ZW', label: 'Zimbabwe' },
  { value: 'XK', label: 'Kosovo' },
];

export const USStates: CountryStateOptionsType[] = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AA', label: 'Armed Forces Americas' },
  { value: 'AP', label: 'Armed Forces Pacific' },
  { value: 'AE', label: 'Armed Forces Europe' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AS', label: 'American Samoa' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DC', label: 'District of Columbia' },
  { value: 'DE', label: 'Delaware' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'GU', label: 'Guam' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'MP', label: 'Northern Mariana Islands' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'PR', label: 'Puerto Rico' },
  { value: 'PW', label: 'Palau' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'VI', label: 'Virgin Islands' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
];

export const supportedCountryStates = ['CA', 'MX', 'US'];

export const CAStates: CountryStateOptionsType[] = [
  { value: 'AB', label: 'Alberta' },
  { value: 'BC', label: 'British Columbia' },
  { value: 'MB', label: 'Manitoba' },
  { value: 'NB', label: 'New Brunswick' },
  { value: 'NL', label: 'Newfoundland and Labrador' },
  { value: 'NS', label: 'Nova Scotia' },
  { value: 'NT', label: 'Northwest Territories' },
  { value: 'NU', label: 'Nunavut' },
  { value: 'ON', label: 'Ontario' },
  { value: 'PE', label: 'Prince Edward Island' },
  { value: 'QC', label: 'Quebec' },
  { value: 'SK', label: 'Saskatchewan' },
  { value: 'YT', label: 'Yukon' },
];

export const MXStates: CountryStateOptionsType[] = [
  { value: 'AG', label: 'Aguascalientes' },
  { value: 'BC', label: 'Baja California' },
  { value: 'BS', label: 'Baja California Sur' },
  { value: 'CM', label: 'Campeche' },
  { value: 'CS', label: 'Chiapas' },
  { value: 'CH', label: 'Chihuahua' },
  { value: 'CO', label: 'Coahuila' },
  { value: 'CL', label: 'Colima' },
  { value: 'DF', label: 'Ciudad de México' },
  { value: 'DG', label: 'Durango' },
  { value: 'GT', label: 'Guanajuato' },
  { value: 'GR', label: 'Guerrero' },
  { value: 'HG', label: 'Hidalgo' },
  { value: 'JA', label: 'Jalisco' },
  { value: 'MX', label: 'Estado de México' },
  { value: 'MI', label: 'Michoacán' },
  { value: 'MO', label: 'Morelos' },
  { value: 'NA', label: 'Nayarit' },
  { value: 'NL', label: 'Nuevo León' },
  { value: 'OA', label: 'Oaxaca' },
  { value: 'PU', label: 'Puebla' },
  { value: 'QT', label: 'Querétaro' },
  { value: 'QR', label: 'Quintana Roo' },
  { value: 'SL', label: 'San Luis Potosí' },
  { value: 'SI', label: 'Sinaloa' },
  { value: 'SO', label: 'Sonora' },
  { value: 'TB', label: 'Tabasco' },
  { value: 'TM', label: 'Tamaulipas' },
  { value: 'TL', label: 'Tlaxcala' },
  { value: 'VE', label: 'Veracruz' },
  { value: 'YU', label: 'Yucatán' },
  { value: 'ZA', label: 'Zacatecas' },
];

/** EU Countries. */
export enum EUCountryEnum {
  AUSTRIA = 'AT',
  BELGIUM = 'BE',
  BULGARIA = 'BG',
  CROATIA = 'HR',
  CYPRUS = 'CY',
  CZECH_REPUBLIC = 'CZ',
  DENMARK = 'DK',
  ESTONIA = 'EE',
  FINLAND = 'FI',
  FRANCE = 'FR',
  GERMANY = 'DE',
  GREECE = 'GR',
  HUNGARY = 'HU',
  IRELAND = 'IE',
  ITALY = 'IT',
  LATVIA = 'LV',
  LITHUANIA = 'LT',
  LUXEMBOURG = 'LU',
  MALTA = 'MT',
  NETHERLANDS = 'NL',
  POLAND = 'PL',
  PORTUGAL = 'PT',
  ROMANIA = 'RO',
  SLOVAKIA = 'SK',
  SLOVENIA = 'SI',
  SPAIN = 'ES',
  SWEDEN = 'SE',
}

export const EU_COUNTRY_LABELS: Record<EUCountryEnum, string> = {
  [EUCountryEnum.AUSTRIA]: 'Austria',
  [EUCountryEnum.BELGIUM]: 'Belgium',
  [EUCountryEnum.BULGARIA]: 'Bulgaria',
  [EUCountryEnum.CROATIA]: 'Croatia',
  [EUCountryEnum.CYPRUS]: 'Cyprus',
  [EUCountryEnum.CZECH_REPUBLIC]: 'Czech Republic',
  [EUCountryEnum.DENMARK]: 'Denmark',
  [EUCountryEnum.ESTONIA]: 'Estonia',
  [EUCountryEnum.FINLAND]: 'Finland',
  [EUCountryEnum.FRANCE]: 'France',
  [EUCountryEnum.GERMANY]: 'Germany',
  [EUCountryEnum.GREECE]: 'Greece',
  [EUCountryEnum.HUNGARY]: 'Hungary',
  [EUCountryEnum.IRELAND]: 'Ireland',
  [EUCountryEnum.ITALY]: 'Italy',
  [EUCountryEnum.LATVIA]: 'Latvia',
  [EUCountryEnum.LITHUANIA]: 'Lithuania',
  [EUCountryEnum.LUXEMBOURG]: 'Luxembourg',
  [EUCountryEnum.MALTA]: 'Malta',
  [EUCountryEnum.NETHERLANDS]: 'Netherlands',
  [EUCountryEnum.POLAND]: 'Poland',
  [EUCountryEnum.PORTUGAL]: 'Portugal',
  [EUCountryEnum.ROMANIA]: 'Romania',
  [EUCountryEnum.SLOVAKIA]: 'Slovakia',
  [EUCountryEnum.SLOVENIA]: 'Slovenia',
  [EUCountryEnum.SPAIN]: 'Spain',
  [EUCountryEnum.SWEDEN]: 'Sweden',
};

export const getStatesOrProvinces = (country_code: string) => {
  switch (country_code) {
    case 'US':
      return USStates;
    case 'CA':
      return CAStates;
    case 'MX':
      return MXStates;
    default:
      if (Object.values(EUCountryEnum).includes(country_code as EUCountryEnum)) {
        return [
          {
            code: country_code,
            label: EU_COUNTRY_LABELS[country_code as EUCountryEnum],
            value: country_code,
          },
        ];
      }
      return [];
  }
};
